import { useEffect, useContext, useState } from 'react';
//import getHotelInfo from '../services/getHotelnfo'
import getDates from '../../services/getDates';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import '../../styles/calendar.scss';
import UserContext from '../../context/userContext';
import CalendarioContext from '../../context/calendarioContext';
import { useNavigate } from 'react-router';
import momentPlugin from '@fullcalendar/moment';
import { diffDates } from '@fullcalendar/core/internal';
import {
  Heading,
  useToast,
  IconButton,
  Alert,
  AlertIcon,
  AlertTitle,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from '@chakra-ui/react';
import obtenerReservaciones from '../../services/obtenerReservaciones';
import { Loading } from '../Common/Loading';
import { obtenerReservacionesAdmin } from '../../services/obtenerReservacionesAdmin';
import { obtenerNoches } from '../../services/obtenerNoches';
import { FaInfoCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Calendario = () => {

  const { t } = useTranslation();

  const today = new Date();
  const { user, setUser } = useContext(UserContext);
  const { date, setDate, dia, setDia, rooms, setRooms } =
    useContext(CalendarioContext);
  const navigate = useNavigate();
  const [reservaciones, setReservaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();

  const [calendarOptions, setCalendarOptions] = useState({
    plugins: [dayGridPlugin, interactionPlugin],
    locale: esLocale,
    initialView: 'dayGridMonth',
    validRange: {
      start: today,
    },
  });

  useEffect(() => {
    setCalendarOptions((prevOptions) => ({
      ...prevOptions,
      validRange: {
        start: today,
      },
    }));
  }, []);

  useEffect(() => {
    (async () => {
      const {
        data: { titular },
      } = await obtenerNoches(user.id);
      if (titular.id) {
        setUser({ ...user, numeroNoches: titular.numeroNoches });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createEvents = () => {
    let newArr = [];
    reservaciones.map((reservacion) => {
      const startDate = new Date(reservacion.fechaLlegada);
      startDate.setDate(startDate.getDate() + 1);

      const endDate = new Date(reservacion.fechaSalida);
      endDate.setDate(endDate.getDate() + 1);

      newArr.push({
        title: reservacion.tipoCabana,
        start: startDate,
        end: endDate,
        backgroundColor: 'rgb(210, 255, 210)',
        textColor: 'black',
        display: 'block',
        allDay: true,
        classNames: ['calendar-text'],
      });
    });
    return newArr;
  };

  let newArr = createEvents();

  useEffect(() => {
    /* getHotelInfo()
      .then((res) => console.log(res.data.hotel))
      .catch((err) => console.error(err)) */
    if (date.dateFrom.trim().length < 1 || date.dateTo.trim().length < 1)
      return;
    else {
      getDates(date.dateFrom, date.dateTo)
        .then((res) => {
          //console.log(res.data.dates)
        })
        .catch((err) => console.error(err));
    }
  }, [date]);

  useEffect(() => {
    setIsLoading(true);
    if (user.rol === 'TITULAR') {
      obtenerReservaciones(user.id)
        .then((res) => {
          if (res.status === 200) {
            setReservaciones(res.data.reservaciones);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setIsLoading(false));
    } else if (user.rol === 'ADMIN') {
      obtenerReservacionesAdmin(user.id)
        .then((res) => {
          if (res.status === 200) {
            setReservaciones(res.data.reservaciones);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (user.moroso) {
    return null;
  }

  // selecciona dia del calendario
  const handleSelect = (e) => {
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startDate = new Date(e.start.getFullYear(), e.start.getMonth(), e.start.getDate());
    if (todayDate.getTime() > startDate.getTime()) {
      toast({
        title: t('PAST_DATE_WARNING'),
        status: 'warning',
        position: 'top',
        isClosable: true,
      });
      return;
    }
    if (user.numeroNoches === 0) {
      toast({
        title: t('NO_AVAILABLE_NIGHTS'),
        status: 'warning',
        position: 'top',
        isClosable: true,
      });
      return;
    }
    
    const numDias = diffDates(e.start, e.end);
    if (numDias.days > user.numeroNoches) {
      toast({
        title: t('EXCEEDS_NIGHTS_WARNING', { nights: user.numeroNoches }),
        status: 'warning',
        position: 'top',
        isClosable: true,
      });
      return;
    } else {
      setDia({ ...e });
      navigate('/reservar');
    }
  };

  const handleEventClick = (e) => {
    console.log(e);
  };

  const handleEvents = (events) => {
    //console.log(events);
  };

  if (isLoading) return <Loading />;

  return (
    <>
      {/* <ReservacionModal
        dia={dia}
        isOpen={isOpen}
        onClose={onClose}
        rooms={rooms}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        user={user}
      /> */}

      {!user.numeroNoches && user.rol === 'TITULAR' && (
        <Alert
          status="error"
          alignItems="center"
          justifyContent="center"
        >
          <AlertIcon />
          <AlertTitle fontSize="lg">
            {t('NO_AVAILABLE_NIGHTS')}
          </AlertTitle>
        </Alert>
      )}

      {!user.admin && (
        <div className="p-2">
          <Heading size={'sm'}>
            {t('SELECT_DATES_TO_RESERVE')}
          </Heading>{' '}
          <span>{t('AVAILABLE_NIGHTS', { nights: user.numeroNoches })}</span>
        </div>
      )}

      <Popover placement="right">
        <PopoverTrigger>
          <IconButton
            icon={<FaInfoCircle />}
            color={'black'}
            bg="rgb(239,184,16)"
            position="fixed"
            top="155px"
            right="25px"
            zIndex="999"
          ></IconButton>
        </PopoverTrigger>
        <PopoverContent border="1px solid rgb(239, 184, 16)">
          <PopoverArrow bg="rgb(239, 184, 16)" />
          <PopoverCloseButton />
          <PopoverBody>
            {t('RESERVATION_INSTRUCTIONS')}
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <div className="demo-app">
        <div className="demo-app-main">
          <FullCalendar
            {...calendarOptions}
            locale={esLocale}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              momentPlugin,
            ]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={true}
            initialEvents={newArr} // alternatively, use the `events` setting to fetch from a feed
            events={newArr}
            select={handleSelect}
            eventContent={renderEventContent} // custom render function
            eventClick={handleEventClick}
            eventsSet={handleEvents} // called after events are initialized/added/changed/removed
            /* you can update a remote database when these fire:
            eventAdd={function(){}}
            eventChange={function(){}}
            eventRemove={function(){}}
            */
            datesSet={(args) => {
              //console.log('###datesSet:', args)
              setDate(
                today.getTime() > args.start.getTime()
                  ? {
                      ...date,
                      dateTo: args.endStr.split('T')[0],
                    }
                  : {
                      dateFrom: args.startStr.split('T')[0],
                      dateTo: args.endStr.split('T')[0],
                    }
              );
            }}
            dateClick={null}
          />
        </div>
      </div>
    </>
  );
};

export default Calendario;

// a custom render function
function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  );
}
